/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { breakpoints } from '@coursera/cds-core';

import HeroBentoCard, {
  type HeroBentoCardType,
} from 'bundles/cds-labs/components/Modules/HeroBentoModule/HeroBentoCard';
import {
  HERO_BENTO_CARD_DESKTOP_WIDTH,
  HERO_BENTO_CARD_DESKTOP_WIDTH_OPTIMIZATION,
  HERO_BENTO_CARD_MOBILE_WIDTH,
  HERO_BENTO_CARD_MOBILE_WIDTH_OPTIMIZATION,
  HERO_BENTO_CARD_TABLET_WIDTH,
  HERO_BENTO_MODULE_TABLET_BREAKPOINT,
} from 'bundles/cds-labs/components/Modules/HeroBentoModule/constants';
import ModuleLayout, { MODULE_LAYOUTS } from 'bundles/cds-labs/components/Modules/ModuleLayout';
import OverflowCarousel from 'bundles/cds-labs/components/OverflowCarousel/OverflowCarousel';

export type HeroBentoModuleProps = {
  cards: HeroBentoCardType[];
  isWiderCard?: boolean;
};

const styles = {
  carousel: css`
    display: grid;
    grid-template-columns: repeat(3, ${HERO_BENTO_CARD_DESKTOP_WIDTH}px);
    grid-template-rows: 1fr;
    gap: var(--cds-spacing-200);

    @media (max-width: ${HERO_BENTO_MODULE_TABLET_BREAKPOINT}px) {
      grid-template-columns: repeat(3, ${HERO_BENTO_CARD_TABLET_WIDTH}px);
    }

    ${breakpoints.down('xs')} {
      grid-template-columns: repeat(3, ${HERO_BENTO_CARD_MOBILE_WIDTH}px);
    }
  `,
  wideCarousel: css`
    display: grid;
    grid-template-columns: repeat(3, ${HERO_BENTO_CARD_DESKTOP_WIDTH_OPTIMIZATION}px);
    grid-template-rows: 1fr;
    gap: var(--cds-spacing-200);

    ${breakpoints.down('sm')} {
      grid-template-columns: repeat(3, ${breakpoints.values.sm - 50}px);
    }

    ${breakpoints.down('xs')} {
      grid-template-columns: repeat(3, ${HERO_BENTO_CARD_MOBILE_WIDTH_OPTIMIZATION}px);
    }
  `,
};

export const HeroBentoModule = ({ cards, isWiderCard = false }: HeroBentoModuleProps) => {
  const contentPanel = () => {
    return (
      <OverflowCarousel
        css={isWiderCard ? styles.wideCarousel : styles.carousel}
        showNavigationButtons
        shouldAllowSpaceForHoverItems
        shouldStartOverflowAtMediumBreakpoint
      >
        {cards.map((card, index) => (
          <HeroBentoCard key={card.id} index={index} {...card} isWiderCard={isWiderCard} />
        ))}
      </OverflowCarousel>
    );
  };

  return (
    <ModuleLayout assembly={{ layout: MODULE_LAYOUTS.noImage, removeTopPadding: true }} renderContent={contentPanel} />
  );
};

export default HeroBentoModule;
